module.exports = __webpack_public_path__ + "static/media/modules.5ec12780.png";